import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="border-b-4 border-volt bg-carbon px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-85" data-mp="eiv62y7sfcld">
      <h1 className="text-[0.8rem] font-extrabold uppercase leading-tight tracking-wide text-steel sm:text-[1.05rem]" data-id="element-86" data-mp="9lla0zpw82ok">
        THE COMPLETE FAULT-FINDING SYSTEM FOR <span className="text-volt" data-id="element-87" data-mp="1297ahz3tqr77">GENERATOR TECHNICIANS</span>
      </h1>
      <p className="mt-1 font-display text-[1.75rem] font-bold uppercase leading-[1.02] text-white sm:text-[2.8rem]" data-id="element-88" data-mp="1274nzp1vrg78">
        STOP GUESSING THE FAULT. <span className="text-volt" data-id="element-89" data-mp="sai3509k0p57">START DIAGNOSING THE SYSTEM.</span>
      </p>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-90" data-mp="ncgjoe87unt7">
        Identify generator faults, follow structured diagnostic paths, record critical measurements,
        isolate possible causes, and verify repairs—all in one organized troubleshooting system.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[280px] sm:max-w-[370px]" data-id="element-91" data-mp="3j895n7fl21mw" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-92" data-mp="3o7lv7zxu9mt6">
        <CTAButton label="🚀 YES! I WANT MY DIAGNOSTIC SYSTEM NOW" data-id="element-93" data-mp="3o6aru18b2h2l" />
        <p className="mt-2 text-[0.68rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-94" data-mp="39aurjeh4toxr">
          🛡️ 7-Day Money-Back Guarantee — Zero Risk
        </p>
      </div>
    </header>;
}